import * as MsDyn365 from '@msdyn365-commerce/core';
import React, { useState } from 'react';
import {
    REGISTER_FIELD_ADDITIONAL_NOTES,
    REGISTER_FIELD_BUSINESS_EMAIL,
    REGISTER_FIELD_COMPANY_NAME,
    REGISTER_FIELD_CONSENT_ACCEPTED,
    REGISTER_FIELD_COUNTRY,
    REGISTER_FIELD_CUSTOMER_NUMBER_OLD_SHOP,
    REGISTER_FIELD_DUNS_ID,
    REGISTER_FIELD_FIRST_NAME,
    REGISTER_FIELD_HAS_PREVIOUS_CONTACT,
    REGISTER_FIELD_INDUSTRY,
    REGISTER_FIELD_LAST_NAME,
    REGISTER_FIELD_ORDER_HISTORY,
    REGISTER_FIELD_PHONE,
    REGISTER_FIELD_PREVIOUS_CONTACT_NAME,
    REGISTER_FIELD_PREVIOUS_CONTACT_WHERE_MET
} from '../../configuration/register';
import { ILxsRegisterViewProps } from './lxs-register';

export default (props: ILxsRegisterViewProps) => {
    const { resources, config, context } = props;
    const CLASS_NAME = 'lxs-register';

    const [hasOldShopOrders, setHasOldShopOrders] = useState<string>('');
    const [hasPreviousContact, setHasPreviousContact] = useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const submittedFormData = new FormData(event.currentTarget);
        const formDataLog: { key: string; value: string }[] = [];

        submittedFormData.forEach((value, key) => {
            formDataLog.push({ key, value: String(value) });
        });

        console.log('lxs-register formData:', formDataLog);
        setIsSubmitted(true);
    };

    return (
        <div className={CLASS_NAME}>
            <div className={`${CLASS_NAME}__header`}>
                {config.title ? (
                    <div className={`${CLASS_NAME}__title`}>
                        <MsDyn365.RichTextComponent
                            text={config.title}
                            editProps={{
                                onEdit: event => (config.title = event.target.value),
                                requestContext: context.request
                            }}
                        />
                    </div>
                ) : (
                    <h1 className={`${CLASS_NAME}__title`}>{resources.lxsRegisterRequestPortalAccessTitle}</h1>
                )}
                {config.subtitle ? (
                    <div className={`${CLASS_NAME}__subtitle`}>
                        <MsDyn365.RichTextComponent
                            text={config.subtitle}
                            editProps={{
                                onEdit: event => (config.subtitle = event.target.value),
                                requestContext: context.request
                            }}
                        />
                    </div>
                ) : (
                    <p className={`${CLASS_NAME}__subtitle`}>{resources.lxsRegisterRequestPortalAccessSubtitle}</p>
                )}
            </div>

            <form className={`${CLASS_NAME}__form`} onSubmit={handleSubmit}>
                <section className={`${CLASS_NAME}__section`}>
                    <h4 className={`${CLASS_NAME}__section-title`}>{resources.lxsRegisterCompanySectionTitle}</h4>

                    <div className={`${CLASS_NAME}__grid`}>
                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-company-name'>
                                {resources.lxsRegisterCompanyNameLabel}
                            </label>
                            <input
                                id='lxs-register-company-name'
                                name={REGISTER_FIELD_COMPANY_NAME}
                                className='msc-form-control'
                                type='text'
                                placeholder={resources.lxsRegisterCompanyNamePlaceholder}
                                required={true}
                            />
                        </div>

                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-duns-id'>
                                {resources.lxsRegisterDunsLabel}
                            </label>
                            <input
                                id='lxs-register-duns-id'
                                name={REGISTER_FIELD_DUNS_ID}
                                className='msc-form-control'
                                type='text'
                                placeholder={resources.lxsRegisterDunsPlaceholder}
                            />
                        </div>
                    </div>

                    <div className={`${CLASS_NAME}__grid`}>
                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-country'>
                                {resources.lxsRegisterCountryLabel}
                            </label>
                            <select
                                id='lxs-register-country'
                                name={REGISTER_FIELD_COUNTRY}
                                className='msc-form-control'
                                defaultValue=''
                                required={true}
                            >
                                <option value='' disabled={true}>
                                    {resources.lxsRegisterCountryPlaceholder}
                                </option>
                                <option value='de'>{resources.lxsRegisterCountryGermany}</option>
                                <option value='at'>{resources.lxsRegisterCountryAustria}</option>
                                <option value='ch'>{resources.lxsRegisterCountrySwitzerland}</option>
                                <option value='nl'>{resources.lxsRegisterCountryNetherlands}</option>
                                <option value='other'>{resources.lxsRegisterCountryOther}</option>
                            </select>
                        </div>

                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-industry'>
                                {resources.lxsRegisterIndustryLabel}
                            </label>
                            <select id='lxs-register-industry' name={REGISTER_FIELD_INDUSTRY} className='msc-form-control' defaultValue=''>
                                <option value='' disabled={true}>
                                    {resources.lxsRegisterIndustryPlaceholder}
                                </option>
                                <option value='chemical'>{resources.lxsRegisterIndustryChemical}</option>
                                <option value='manufacturing'>{resources.lxsRegisterIndustryManufacturing}</option>
                                <option value='agriculture'>{resources.lxsRegisterIndustryAgriculture}</option>
                                <option value='other'>{resources.lxsRegisterIndustryOther}</option>
                            </select>
                        </div>
                    </div>
                </section>

                <section className={`${CLASS_NAME}__section`}>
                    <h4 className={`${CLASS_NAME}__section-title`}>{resources.lxsRegisterContactPersonSectionTitle}</h4>

                    <div className={`${CLASS_NAME}__grid`}>
                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-first-name'>
                                {resources.lxsRegisterFirstNameLabel}
                            </label>
                            <input
                                id='lxs-register-first-name'
                                name={REGISTER_FIELD_FIRST_NAME}
                                className='msc-form-control'
                                type='text'
                                placeholder={resources.lxsRegisterFirstNamePlaceholder}
                                required={true}
                            />
                        </div>

                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-last-name'>
                                {resources.lxsRegisterLastNameLabel}
                            </label>
                            <input
                                id='lxs-register-last-name'
                                name={REGISTER_FIELD_LAST_NAME}
                                className='msc-form-control'
                                type='text'
                                placeholder={resources.lxsRegisterLastNamePlaceholder}
                                required={true}
                            />
                        </div>
                    </div>

                    <div className={`${CLASS_NAME}__grid`}>
                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-business-email'>
                                {resources.lxsRegisterBusinessEmailLabel}
                            </label>
                            <input
                                id='lxs-register-business-email'
                                name={REGISTER_FIELD_BUSINESS_EMAIL}
                                className='msc-form-control'
                                type='email'
                                placeholder={resources.lxsRegisterBusinessEmailPlaceholder}
                                required={true}
                            />
                        </div>

                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-phone'>
                                {resources.lxsRegisterPhoneLabel}
                            </label>
                            <input
                                id='lxs-register-phone'
                                name={REGISTER_FIELD_PHONE}
                                className='msc-form-control'
                                type='tel'
                                placeholder={resources.lxsRegisterPhonePlaceholder}
                            />
                        </div>
                    </div>
                </section>

                <section className={`${CLASS_NAME}__section`}>
                    <h4 className={`${CLASS_NAME}__section-title`}>{resources.lxsRegisterOrderHistorySectionTitle}</h4>

                    <fieldset className={`msc-form__group ${CLASS_NAME}__order-history-group`}>
                        <legend className='msc-form-label'>{resources.lxsRegisterOrderHistoryQuestionLabel}</legend>

                        <div className={`${CLASS_NAME}__order-history-group-grid`}>
                            <label className={`msc-form__radio ${CLASS_NAME}__radio-card`}>
                                <input
                                    type='radio'
                                    name={REGISTER_FIELD_ORDER_HISTORY}
                                    value='existing'
                                    checked={hasOldShopOrders === 'existing'}
                                    onChange={event => setHasOldShopOrders(event.target.value)}
                                    required={true}
                                />
                                <span className={`${CLASS_NAME}__option-title`}>{resources.lxsRegisterOrderHistoryExistingOption}</span>
                                <small className={`${CLASS_NAME}__helper-text`}>{resources.lxsRegisterOrderHistoryExistingHint}</small>
                            </label>

                            <label className={`msc-form__radio ${CLASS_NAME}__radio-card`}>
                                <input
                                    type='radio'
                                    name={REGISTER_FIELD_ORDER_HISTORY}
                                    value='new'
                                    checked={hasOldShopOrders === 'new'}
                                    onChange={event => setHasOldShopOrders(event.target.value)}
                                />
                                <span className={`${CLASS_NAME}__option-title`}>{resources.lxsRegisterOrderHistoryNewOption}</span>
                                <small className={`${CLASS_NAME}__helper-text`}>{resources.lxsRegisterOrderHistoryNewHint}</small>
                            </label>
                        </div>
                    </fieldset>

                    {hasOldShopOrders === 'existing' && (
                        <div className='msc-form__group'>
                            <label className='msc-form-label' htmlFor='lxs-register-customer-number'>
                                {resources.lxsRegisterCustomerNumberLabel}
                            </label>
                            <input
                                id='lxs-register-customer-number'
                                name={REGISTER_FIELD_CUSTOMER_NUMBER_OLD_SHOP}
                                className='msc-form-control'
                                type='text'
                                placeholder={resources.lxsRegisterCustomerNumberPlaceholder}
                            />
                            <small className={`${CLASS_NAME}__helper-text`}>{resources.lxsRegisterCustomerNumberHint}</small>
                        </div>
                    )}
                </section>

                <section className={`${CLASS_NAME}__section`}>
                    <h4 className={`${CLASS_NAME}__section-title`}>{resources.lxsRegisterPreviousContactSectionTitle}</h4>
                    <div className={`${CLASS_NAME}__previous-contact-card`}>
                        <p className={`${CLASS_NAME}__helper-text ${CLASS_NAME}__previous-contact-card-hint`}>
                            {resources.lxsRegisterPreviousContactSectionHint}
                        </p>

                        <label className={`msc-form__check ${CLASS_NAME}__previous-contact-toggle`}>
                            <input
                                id='lxs-register-previous-contact'
                                name={REGISTER_FIELD_HAS_PREVIOUS_CONTACT}
                                type='checkbox'
                                checked={hasPreviousContact}
                                onChange={event => setHasPreviousContact(event.target.checked)}
                            />
                            <span>{resources.lxsRegisterPreviousContactCheckboxLabel}</span>
                        </label>

                        {hasPreviousContact && (
                            <div className={`${CLASS_NAME}__grid`}>
                                <div className='msc-form__group'>
                                    <label className='msc-form-label' htmlFor='lxs-register-contact-name'>
                                        {resources.lxsRegisterPreviousContactNameLabel}
                                    </label>
                                    <input
                                        id='lxs-register-contact-name'
                                        name={REGISTER_FIELD_PREVIOUS_CONTACT_NAME}
                                        className='msc-form-control'
                                        type='text'
                                        placeholder={resources.lxsRegisterPreviousContactNamePlaceholder}
                                    />
                                </div>

                                <div className='msc-form__group'>
                                    <label className='msc-form-label' htmlFor='lxs-register-where-met'>
                                        {resources.lxsRegisterPreviousContactWhereLabel}
                                    </label>
                                    <input
                                        id='lxs-register-where-met'
                                        name={REGISTER_FIELD_PREVIOUS_CONTACT_WHERE_MET}
                                        className='msc-form-control'
                                        type='text'
                                        placeholder={resources.lxsRegisterPreviousContactWherePlaceholder}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </section>

                <section className={`${CLASS_NAME}__section`}>
                    <div className='msc-form__group'>
                        <label className='msc-form-label' htmlFor='lxs-register-notes'>
                            {resources.lxsRegisterAdditionalNotesLabel}
                        </label>
                        <textarea
                            id='lxs-register-notes'
                            name={REGISTER_FIELD_ADDITIONAL_NOTES}
                            className='msc-form-control'
                            rows={4}
                            placeholder={resources.lxsRegisterAdditionalNotesPlaceholder}
                        />
                    </div>

                    <label className={`msc-form__check ${CLASS_NAME}__consent`}>
                        <input id='lxs-register-consent' name={REGISTER_FIELD_CONSENT_ACCEPTED} type='checkbox' required={true} />
                        <span>{resources.lxsRegisterConsentLabel}</span>
                    </label>
                </section>

                <div className={`${CLASS_NAME}__actions`}>
                    <button className='msc-btn msc-cta__primary' type='submit'>
                        {resources.lxsRegisterSubmitButtonText}
                    </button>
                    {isSubmitted && (
                        <p className={`${CLASS_NAME}__success`} role='status'>
                            {resources.lxsRegisterSubmitSuccessText}
                        </p>
                    )}
                </div>
            </form>
        </div>
    );
};
